import React from 'react';
import { Reveal } from './Reveal';
import { ArrowUpRight, Play, Mic, Video } from 'lucide-react';

export const ReportCard = ({ report, onClick, index }) => {
  const isPodcast = report.category === 'PODCAST';
  const isVideo = report.category === 'VIDEO' || report.mediaType === 'video';
  const isPlayable = isPodcast || isVideo;

  return (
    <Reveal delay={index * 100}>
      <div
        onClick={onClick}
        className="group relative aspect-[4/5] bg-zinc-100 overflow-hidden cursor-pointer"
      >
        {/* Background Image */}
        <div className="absolute inset-0 transition-transform duration-700 group-hover:scale-105">
          <img
            src={report.image}
            alt={report.title}
            className="w-full h-full object-cover"
          />
          {/* Elegant Gradient Overlay */}
          <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-60 group-hover:opacity-80 transition-opacity duration-500" />
        </div>

        {/* Content Overlay */}
        <div className="absolute inset-0 p-8 flex flex-col justify-between z-10">
          {/* Top: Category & Meta */}
          <div className="flex items-start justify-between">
            <div className="flex flex-col gap-2">
              <span className="text-[10px] font-bold uppercase tracking-[0.2em] text-white/90 bg-white/10 backdrop-blur-md px-3 py-1 self-start">
                {report.category}
              </span>
              {isPodcast && (
                <div className="flex items-center gap-2 text-white/70 text-[10px] font-mono tracking-widest">
                  <Mic size={10} />
                  <span>LONG FORM</span>
                </div>
              )}
              {isVideo && (
                <div className="flex items-center gap-2 text-white/70 text-[10px] font-mono tracking-widest">
                  <Video size={10} />
                  <span>WATCH</span>
                </div>
              )}
            </div>
            
            <div className="w-10 h-10 rounded-full bg-white/10 backdrop-blur-md border border-white/20 flex items-center justify-center text-white opacity-0 group-hover:opacity-100 group-hover:scale-110 transition-all duration-500">
              {isPlayable ? <Play size={16} className="ml-1" /> : <ArrowUpRight size={18} />}
            </div>
          </div>

          {/* Bottom: Title & Info */}
          <div className="transform translate-y-4 group-hover:translate-y-0 transition-transform duration-500">
            <div className="text-white/60 text-[10px] font-mono tracking-[0.2em] mb-3">
              {report.date} // {report.readTime}
            </div>
            <h3 className="text-2xl md:text-3xl font-bold text-white leading-[1.1] mb-2 tracking-tight font-sans">
              {report.title}
            </h3>
            <div className="h-px w-0 group-hover:w-full bg-white/30 transition-all duration-700 mb-4" />
            <p className="text-white/70 text-sm font-medium opacity-0 group-hover:opacity-100 transition-opacity duration-500 delay-100">
              By {report.author}
            </p>
          </div>
        </div>
      </div>
    </Reveal>
  );
};
